const ARTICLE_IMG =
  "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/B.jpg";

const buildArticle = (id, feedId, publishedAt) => ({
  id,
  name: `Article ${id}`,
  description: `Description ${id}`,
  url: "https://www.google.com",
  imgurl: ARTICLE_IMG,
  category: `Category ${((id - 1) % 3) + 1}`,
  category_id: ((id - 1) % 3) + 1,
  article_feed_id: feedId,
  published_at: publishedAt,
  published_by: `Author ${id}`,
});

// Feed 1: 12 articles (3 pages × 5), Feed 2: 6 articles (2 pages),
// Feed 3: 2 articles (1 page). Sorted by published_at DESC, id DESC
// to match keyset-pagination expectations on the ECM (DynamoDB) side.
const articles = [
  ...Array.from({ length: 12 }, (_, i) =>
    buildArticle(100 + i, 1, 1709211466 - i * 3600)
  ),
  ...Array.from({ length: 6 }, (_, i) =>
    buildArticle(200 + i, 2, 1709200000 - i * 3600)
  ),
  ...Array.from({ length: 2 }, (_, i) =>
    buildArticle(300 + i, 3, 1709100000 - i * 3600)
  ),
];

const products = [
  {
    product_feed_id: 36,
    currency: "Kč",
    description: "asdasd",
    id: 6,
    img_url:
      "https://cdn.myshoptet.com/usr/eshop.contexta.cz/user/shop/orig/44_hra-na-konverzaci-i-gramatiku--nemcina--cubito-de.jpg?5ee8d110",
    name: "Contexta Hra CUBITO DE - komplet",
    price_before: null,
    price_with_vat: 1500,
    url: "https://eshop.contexta.cz/zbozi/cubito-de/",
    category_id: 101,
  },
  {
    id: 67,
    product_feed_id: 36,
    custom_id: "TV_123456",
    name: 'LG 22LB4510 - 22" LED TV - 1080p (FullHD)',
    product: 'LG 22LB4510 - 22" LED TV - 1080p (FullHD)',
    description:
      'Attractively styled and boasting stunning picture quality, the LG 22LB4510 - 22" LED TV - 1080p (FullHD) is an excellent television/monitor. The LG 22LB4510 - 22" LED TV - 1080p (FullHD) sports a widescreen 1080p panel, perfect for watching movies in their original format, whilst also providing plenty of working space for your other applications.',
    url: "http://www.example.com/electronics/tv/22LB4510.html",
    img_url:
      "https://images.pexels.com/photos/333984/pexels-photo-333984.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    img_url_alternative: "http://images.example.com/TV_123456.png",
    price_with_vat: 159,
    price_before: 199,
    currency: "CZK",
    manufacturer: "LG",
    category: null,
    category_id: 102,
    category_text: "Electronics > Video > Televisions > Flat Panel Televisions",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 68,
    product_feed_id: 37,
    custom_id: "DVD-0564738",
    name: "Merlin: Series 3 - Volume 2 - 3 DVD Box set",
    product: "Merlin: Series 3 - Volume 2 - 3 DVD Box set",
    description:
      "Episodes 7-13 from the third series of the BBC fantasy drama set in the mythical city of Camelot, telling the tale of the relationship between the young King Arthur (Bradley James) & Merlin (Colin Morgan), the wise sorcerer who guides him to power and beyond. Episodes are: 'The Castle of Fyrien', 'The Eye of the Phoenix', 'Love in the Time of Dragons', 'Queen of Hearts', 'The Sorcerer's Shadow', 'The Coming of Arthur: Part 1' & 'The Coming of Arthur: Part 2'",
    url: "http://www.example.com/media/dvd/?sku=384616&src=gshopping&lang=en",
    img_url:
      "https://images.pexels.com/photos/333984/pexels-photo-333984.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    img_url_alternative:
      "http://images.example.com/DVD-0564738?size=large&format=PNG",
    price_with_vat: 11.99,
    price_before: 14.99,
    currency: "Kč",
    manufacturer: "BBC",
    category: null,
    category_id: 103,
    category_text: "Media > DVDs & Videos",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 69,
    product_feed_id: 37,
    custom_id: "PFM654321",
    name: "Dior Capture XP Ultimate Wrinkle Correction Creme 1.7 oz",
    product: "Dior Capture XP Ultimate Wrinkle Correction Creme 1.7 oz",
    description:
      "Dior Capture XP Ultimate Wrinkle Correction Creme 1.7 oz reinvents anti-wrinkle care by protecting and relaunching skin cell activity to encourage faster, healthier regeneration.",
    url: "http://www.example.com/perfumes/product?Dior%20Capture%20R6080%20XP",
    img_url:
      "https://images.pexels.com/photos/333984/pexels-photo-333984.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
    img_url_alternative: "http://images.example.com/PFM654321_1.jpg",
    price_with_vat: 99,
    price_before: null,
    currency: "K",
    manufacturer: "Dior",
    category: null,
    category_id: 104,
    category_text:
      "Health & Beauty > Personal Care > Cosmetics > Skin Care > Anti-Aging Skin Care Kits",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 70,
    product_feed_id: 37,
    custom_id: "CLO-29473856-1",
    name: "Roma Cotton Rich Bootcut Jeans - Size 8 Standard",
    product: "Roma Cotton Rich Bootcut Jeans - Size 8 Standard",
    description: "A smart pair of bootcut jeans in stretch cotton.",
    url: "http://www.example.com/clothing/women/Roma-Cotton-Bootcut-Jeans/?extid=CLO-29473856",
    img_url: "http://images.example.com/CLO-29473856-front.jpg",
    img_url_alternative: "http://images.example.com/CLO-29473856-front.jpg",
    price_with_vat: 29.5,
    price_before: null,
    currency: "USD",
    manufacturer: "M&S",
    category: null,
    category_id: 105,
    category_text: "Apparel & Accessories > Clothing > Pants > Jeans",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 71,
    product_feed_id: 37,
    custom_id: "CLO-29473856-2",
    name: "EUR Roma Cotton Rich Bootcut Jeans - Size 8 Tall",
    product: "Roma Cotton Rich Bootcut Jeans - Size 8 Tall",
    description: "A smart pair of bootcut jeans in stretch cotton.",
    url: "http://www.example.com/clothing/women/Roma-Cotton-Bootcut-Jeans/?extid=CLO-29473856",
    img_url: "http://images.example.com/CLO-29473856-front.jpg",
    img_url_alternative: "http://images.example.com/CLO-29473856-front.jpg",
    price_with_vat: 29.5,
    price_before: null,
    currency: "EUR",
    manufacturer: "M&S",
    category: null,
    category_id: 105,
    category_text: "Apparel & Accessories > Clothing > Pants > Jeans",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 72,
    product_feed_id: 37,
    custom_id: "CLO-1029384",
    name: "€ Tenn Cool Flow Ladies Long Sleeved Cycle Jersey",
    product: "Tenn Cool Flow Ladies Long Sleeved Cycle Jersey",
    description:
      "A ladies' cycling jersey designed for the serious cyclist, tailored to fit a feminine frame. This sporty, vibrant red, black and white jersey is constructed of a special polyester weave that is extremely effective at drawing moisture away from your body, helping to keep you dry.  With an elasticised, gripping waist, it will stay in place for the duration of your cycle, and won't creep up like many other products. It has two elasticised rear pockets and the sleeves are elasticated to prevent creep-up.",
    url: "http://www.example.com/clothing/sports/product?id=CLO1029384&src=gshopping&popup=false",
    img_url: "http://images.example.com/CLO-1029384.jpg",
    img_url_alternative: "http://images.example.com/CLO-1029384.jpg",
    price_with_vat: 33.99,
    price_before: 39.99,
    currency: "€",
    manufacturer: "Tenn Cool",
    category: null,
    category_id: 106,
    category_text:
      "Apparel & Accessories > Clothing > Activewear > Bicycle Activewear > Bicycle Jerseys",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 73,
    product_feed_id: 37,
    custom_id: "DVD-0564738",
    name: "Merlin: Series 3 - Volume 2 - 3 DVD Box set",
    product: "Me4rlin: Series 3 - Volume 2 - 3 DVD Box set",
    description:
      "Episodes 7-13 from the third series of the BBC fantasy drama set in the mythical city of Camelot, telling the tale of the relationship between the young King Arthur (Bradley James) & Merlin (Colin Morgan), the wise sorcerer who guides him to power and beyond. Episodes are: 'The Castle of Fyrien', 'The Eye of the Phoenix', 'Love in the Time of Dragons', 'Queen of Hearts', 'The Sorcerer's Shadow', 'The Coming of Arthur: Part 1' & 'The Coming of Arthur: Part 2'",
    url: "http://www.example.com/media/dvd/?sku=384616&src=gshopping&lang=en",
    img_url: "http://images.example.com/DVD-0564738?size=large&format=PNG",
    img_url_alternative:
      "http://images.example.com/DVD-0564738?size=large&format=PNG",
    price_with_vat: 11.99,
    price_before: null,
    currency: "USD",
    manufacturer: "BBC",
    category: null,
    category_id: 103,
    category_text: "Media > DVDs & Videos",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 74,
    product_feed_id: 37,
    custom_id: "PFM654321",
    name: "Dior Capture XP Ultimate Wrinkle Correction Creme 1.7 oz",
    product: "Dior Capture XP Ultimate Wrinkle Correction Creme 1.7 oz",
    description:
      "Dior Capture XP Ultimate Wrinkle Correction Creme 1.7 oz reinvents anti-wrinkle care by protecting and relaunching skin cell activity to encourage faster, healthier regeneration.",
    url: "http://www.example.com/perfumes/product?Dior%20Capture%20R6080%20XP",
    img_url: "http://images.example.com/PFM654321_1.jpg",
    img_url_alternative: "http://images.example.com/PFM654321_1.jpg",
    price_with_vat: 99,
    price_before: null,
    currency: "USD",
    manufacturer: "Dior",
    category: null,
    category_id: 104,
    category_text:
      "Health & Beauty > Personal Care > Cosmetics > Skin Care > Anti-Aging Skin Care Kits",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 75,
    product_feed_id: 37,
    custom_id: "CLO-29473856-1",
    name: "Roma Cotton Rich Bootcut Jeans - Size 8 Standard",
    product: "Roma Cotton Rich Bootcut Jeans - Size 8 Standard",
    description: "A smart pair of bootcut jeans in stretch cotton.",
    url: "http://www.example.com/clothing/women/Roma-Cotton-Bootcut-Jeans/?extid=CLO-29473856",
    img_url: "http://images.example.com/CLO-29473856-front.jpg",
    img_url_alternative: "http://images.example.com/CLO-29473856-front.jpg",
    price_with_vat: 29.5,
    price_before: null,
    currency: "USD",
    manufacturer: "M&S",
    category: null,
    category_id: 105,
    category_text: "Apparel & Accessories > Clothing > Pants > Jeans",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
  {
    id: 76,
    product_feed_id: 37,
    custom_id: "CLO-29473856-2",
    name: "Roma Cotton Rich Bootcut Jeans - Size 8 Tall",
    product: "Roma Cotton Rich Bootcut Jeans - Size 8 Tall",
    description: "A smart pair of bootcut jeans in stretch cotton.",
    url: "http://www.example.com/clothing/women/Roma-Cotton-Bootcut-Jeans/?extid=CLO-29473856",
    img_url: "http://images.example.com/CLO-29473856-front.jpg",
    img_url_alternative: "http://images.example.com/CLO-29473856-front.jpg",
    price_with_vat: 29.5,
    price_before: null,
    currency: "USD",
    manufacturer: "M&S",
    category: null,
    category_id: 105,
    category_text: "Apparel & Accessories > Clothing > Pants > Jeans",
    created_at: "2020-10-10 11:05:44",
    updated_at: "2020-10-10 11:05:44",
  },
];

const myBlocks = [
  {
    id: 1,
    name: "Block 1",
    image:
      "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/warsaw.jpg",
    href: "https://www.topol.io",
    "my-text-1": "My text 1 in block 1",
    "my-text-2": "My text 2 in block 1",
    "my-text-3": "My text 3 in block 1",
    feed_id: 1,
    category_id: 11,
  },
  {
    id: 2,
    name: "Block 2",
    image:
      "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/prague.jpg",
    href: "https://www.topol.io",
    "my-text-1": "My text 1 in block 2",
    "my-text-2": "My text 2 in block 2",
    "my-text-3": "My text 3 in block 2",
    feed_id: 1,
    category_id: 12,
  },
  {
    id: 3,
    name: "Block 3",
    image:
      "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/bridge.jpg",
    href: "https://www.topol.io",
    "my-text-1": "My text 1 in block 3",
    "my-text-2": "My text 2 in block 3",
    "my-text-3": "My text 3 in block 3",
    feed_id: 1,
    category_id: 11,
  },
  {
    id: 4,
    name: "Block 4",
    image:
      "https://storage.googleapis.com/topol-io-plugin-97de3577-4897-4379-9699-a51756301fab/plugin-assets/17326/user/warsaw.jpg",
    href: "https://www.topol.io",
    "my-text-1": "My text 1 in block 4",
    "my-text-2": "My text 2 in block 4",
    "my-text-3": "My text 3 in block 4",
    feed_id: 2,
    category_id: 13,
  },
];

const feeds = [
  {
    id: 1,
    name: "Feed 1",
  },
  {
    id: 2,
    name: "Feed 2",
  },
  {
    id: 3,
    name: "Feed 3",
  },
  {
    id: 4,
    name: "Feed 4",
  },
];

const productFeeds = [
  {
    id: 37,
    name: "Test",
    type: "GOOGLE",
    url: "https://app.topol.io/example_product_feed.xml",
    user_id: 6320,
    products_count: 6,
    status: "SYNCED",
    error: null,
    auth: null,
    last_synced_at: null,
    created_at: "2020-10-10 07:09:35",
    updated_at: "2020-10-10 07:09:36",
  },
  {
    id: 36,
    name: "Test 2",
    type: "GOOGLE",
    url: "https://app.topol.io/example_product_feed.xml",
    user_id: 6320,
    products_count: 6,
    status: "SYNCED",
    error: null,
    auth: null,
    last_synced_at: null,
    created_at: "2020-10-10 07:09:35",
    updated_at: "2020-10-10 07:09:36",
  },
];

const myBlockCategories = [
  { id: 11, name: "Cities", feed_id: 1 },
  { id: 12, name: "Landmarks", feed_id: 1 },
  { id: 13, name: "Nature", feed_id: 2 },
  { id: 14, name: "People", feed_id: 2 },
  { id: 15, name: "Food", feed_id: 3 },
];

const productCategories = [
  { id: 101, name: "Toys & Games", feed_id: 36 },
  { id: 102, name: "Electronics", feed_id: 36 },
  { id: 103, name: "Media", feed_id: 37 },
  { id: 104, name: "Beauty", feed_id: 37 },
  { id: 105, name: "Clothing", feed_id: 37 },
  { id: 106, name: "Sports", feed_id: 37 },
];

const articleCategories = [
  { id: 1, name: "Category 1", feed_id: 1 },
  { id: 2, name: "Category 2", feed_id: 1 },
  { id: 3, name: "Category 3", feed_id: 2 },
];

const jsonResponse = (body) =>
  new Response(JSON.stringify(body), {
    status: 200,
    headers: { "Content-Type": "application/json" },
  });

const paginate = (items, perPage, currentPage) => {
  const start = (currentPage - 1) * perPage;
  return items.slice(start, start + perPage);
};

const filterBySearch = (items, search, fields = ["name"]) => {
  if (!search) return items;
  const q = String(search).toLowerCase();
  return items.filter((it) =>
    fields.some((f) =>
      String(it[f] ?? "")
        .toLowerCase()
        .includes(q)
    )
  );
};

const getParams = (request) =>
  Object.fromEntries(new URL(request.url).searchParams);

const ARTICLE_PER_PAGE = 5;

// Simulates the ECM DynamoDB keyset pagination: sorts by published_at DESC
// then id DESC, then returns up to ARTICLE_PER_PAGE items AFTER the cursor
// carried in { next, published_at } query params.
export const getAllArticles = ({ request }) => {
  const params = getParams(request);
  let filtered = [...articles];
  const feedId = params.feed_id || params.feed;
  if (feedId) {
    filtered = filtered.filter(
      (a) => String(a.article_feed_id) === String(feedId)
    );
  }
  if (params.category_id) {
    filtered = filtered.filter(
      (a) => String(a.category_id) === String(params.category_id)
    );
  }

  filtered.sort((a, b) => {
    if (b.published_at !== a.published_at) {
      return b.published_at - a.published_at;
    }
    return Number(b.id) - Number(a.id);
  });

  const cursorId = params.next;
  const cursorPublishedAt = params.published_at
    ? Number(params.published_at)
    : undefined;
  let startIdx = 0;
  if (cursorId !== undefined && cursorPublishedAt !== undefined) {
    const idx = filtered.findIndex(
      (a) =>
        String(a.id) === String(cursorId) &&
        Number(a.published_at) === cursorPublishedAt
    );
    startIdx = idx >= 0 ? idx + 1 : 0;
  }

  const page = filtered.slice(startIdx, startIdx + ARTICLE_PER_PAGE);
  const hasMore = startIdx + page.length < filtered.length;
  const last = page[page.length - 1];

  return jsonResponse({
    success: true,
    data: page,
    next:
      hasMore && last
        ? { post_id: String(last.id), published_at: String(last.published_at) }
        : [],
  });
};

export const getAllFeeds = ({ request }) => {
  const params = getParams(request);
  const per_page = Number(params.per_page) || 10;
  const current_page = Number(params.current_page) || 1;
  const search = params.search;

  let filtered = feeds;
  filtered = filterBySearch(filtered, search);

  const total = filtered.length;
  const paged = paginate(filtered, per_page, current_page);

  return jsonResponse({
    success: true,
    data: paged,
    from: (current_page - 1) * per_page + 1,
    to: (current_page - 1) * per_page + paged.length,
    total_records: total,
    per_page,
    current_page,
    last_page: Math.max(1, Math.ceil(total / per_page)),
  });
};

export const getProductFeeds = ({ request }) => {
  const params = getParams(request);
  const per_page = Number(params.per_page) || 10;
  const current_page = Number(params.current_page) || 1;
  const search = params.search;

  let filtered = productFeeds;
  filtered = filterBySearch(filtered, search);

  const total = filtered.length;
  const paged = paginate(filtered, per_page, current_page);

  return jsonResponse({
    success: true,
    data: paged,
    from: (current_page - 1) * per_page + 1,
    to: (current_page - 1) * per_page + paged.length,
    total_records: total,
    per_page,
    current_page,
    last_page: Math.max(1, Math.ceil(total / per_page)),
  });
};

export const getMyBlocks = ({ request }) => {
  const params = getParams(request);
  const per_page = Number(params.per_page) || 10;
  const current_page = Number(params.current_page) || 1;

  let filtered = JSON.parse(JSON.stringify(myBlocks));
  const feedId = params.feed_id || params.feed;
  if (feedId) {
    filtered = filtered.filter((b) => String(b.feed_id) === String(feedId));
  }
  if (params.category_id) {
    filtered = filtered.filter(
      (b) => String(b.category_id) === String(params.category_id)
    );
  }
  filtered = filterBySearch(filtered, params.search);

  const total = filtered.length;
  const paged = paginate(filtered, per_page, current_page);

  return jsonResponse({
    success: true,
    data: paged,
    from: (current_page - 1) * per_page + 1,
    to: (current_page - 1) * per_page + paged.length,
    total_records: total,
    per_page,
    current_page,
    last_page: Math.max(1, Math.ceil(total / per_page)),
  });
};

export const getProducts = ({ request }) => {
  const params = getParams(request);
  const per_page = Number(params.per_page) || 10;
  const current_page = Number(params.current_page) || 1;
  const category_id = params.category_id;

  let filtered = JSON.parse(JSON.stringify(products));
  const feedId = params.feed_id || params.feed;
  if (feedId) {
    filtered = filtered.filter(
      (p) => String(p.product_feed_id) === String(feedId)
    );
  }
  if (category_id) {
    filtered = filtered.filter(
      (p) => String(p.category_id) === String(category_id)
    );
  }
  filtered = filterBySearch(filtered, params.search, ["name", "product"]);

  const total = filtered.length;
  const paged = paginate(filtered, per_page, current_page);

  return jsonResponse({
    success: true,
    data: paged,
    from: (current_page - 1) * per_page + 1,
    to: (current_page - 1) * per_page + paged.length,
    total_records: total,
    per_page,
    current_page,
    last_page: Math.max(1, Math.ceil(total / per_page)),
  });
};

const buildCategoriesResponse =
  (allCategories) =>
  ({ request }) => {
    const params = getParams(request);
    const per_page = Number(params.per_page) || 10;
    const current_page = Number(params.current_page) || 1;

    let filtered = allCategories;
    const feedId = params.feed_id || params.feed;
    if (feedId) {
      filtered = filtered.filter((c) => String(c.feed_id) === String(feedId));
    }
    filtered = filterBySearch(filtered, params.search);

    const total = filtered.length;
    const paged = paginate(filtered, per_page, current_page);

    return jsonResponse({
      success: true,
      data: paged,
      from: (current_page - 1) * per_page + 1,
      to: (current_page - 1) * per_page + paged.length,
      total_records: total,
      per_page,
      current_page,
      last_page: Math.max(1, Math.ceil(total / per_page)),
    });
  };

export const getMyBlockCategories = buildCategoriesResponse(myBlockCategories);
export const getProductCategories = buildCategoriesResponse(productCategories);
export const getArticleCategories = buildCategoriesResponse(articleCategories);
